enum UserType {
  FETCH_USER = "USER/FETCH_USER",
  FETCH_USER_SUCCESS = "USER/FETCH_USER_SUCCESS",
}

interface UserState {}
export default UserType;
export { UserState };
